module.exports = function getResource(label, vars = []) {
    let resources = {
        inStoreServices: 'In-store Services',
        makeoverAt: '- Makeover at',
        findStore: 'Find in store'
    };
    return resources[label];
};
